import { Badge } from '@/lib/base/badges/badges';

interface TokenBadgeProps {
  label: string;
}

export function TokenBadge({ label }: TokenBadgeProps) {
  return (
    <Badge type='pill-color' className='inline-flex align-middle'>
      {label}
    </Badge>
  );
}
